import React, { FC } from "react";
interface ButtonPrimaryProps {
    additionalClassName?: string
    title: string
    onClick: () => void
}

export const ButtonPrimary: FC<ButtonPrimaryProps> = ({ title, onClick, additionalClassName }) => {
    let className = 'text-sm sm:text-base font-medium font-body text-white bg-accent-100 py-2 px-4 sm:px-8 sm:py-3 rounded hover:bg-secondary-100 transition duration-300 ease-out'

    className += ` ${additionalClassName ?? ""}`;
    return (
        <button className={className} onClick={onClick}>
            <p>{title ?? 'Ok'}</p>
        </button>
    )
}